export const getUser = store => {
  return store.user
}

export const getUserInfo = store => {
  return store.userinfo
}

export const getWritePrivilege = store => {
  return store.userinfo.adminlevel == 0 || store.userinfo.adminlevel == 1
}

export const getReadPrivilege = store => {
  return store.userinfo.adminlevel == 0 || store.userinfo.adminlevel == 1 || store.userinfo.adminlevel == 2
}

export const getOrderPrivilege = store => {
  return store.userinfo.adminlevel == 0 || store.userinfo.adminlevel == 1 || store.userinfo.adminlevel == 2 || store.userinfo.adminlevel == 4
}

export const getReadTagOrderPrivilege = store => {
  return store.userinfo.enable_order == 1 && (store.userinfo.adminlevel == 0 || store.userinfo.adminlevel == 1 || store.userinfo.adminlevel == 2 || store.userinfo.adminlevel == 3)
}

export const getCancelOrderPrivilege = store => {
  return store.userinfo.enable_cancel == 1
}

export const getEnableOrderPrivilege = store => {
  return store.userinfo.enable_order == 1
}

export const getAdminPrivilege = store => {
  return store.userinfo.adminlevel == 0 
}

export const getDBHistoryDatas = store => (days) => {
  const orderDatas = store.dashboard.orderDatas.slice(0, days)
  // const categoryDatas = store.dashboard.categoryDatas[`dataFor${days}Days`]
  const productDatas = store.dashboard.productDatas[`dataFor${days}Days`]
  return {orderDatas, productDatas}
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js